/* ==========================================================================
   Små ting der skal køre på hver side

   1) Fang "tilføj til kurv", uanset hvem der har lavet knappen.
      Butikken har tre slags: Dawns egen, GemPages' (.gp-button-atc) og
      Kaching Bundles'. GemPages sender en helt almindelig
      <form action="/cart/add"> af sted, så browseren skifter side — det kan
      hverken fetch- eller XHR-lytteren opdage. Her gribes selve indsendelsen
      i stedet, så varen lægges i kurven via Ajax og drawer'en åbner.

      Har en app allerede håndteret indsendelsen (preventDefault), holder vi
      os helt ude. Går noget galt, sendes formularen som før, så kunden
      aldrig ender med en knap der ikke virker.

   2) Flyt sko-vælgeren ud i bunden af <body>. Den renderes inde i
      header-sektionen, og derfra kan den ikke lande oven på drawer'en,
      uanset z-index.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 1) tilføj til kurv ---------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (!form.matches('form[action*="/cart/add"]')) return;

    /* En app har taget over — lad den om det */
    if (e.defaultPrevented) return;

    e.preventDefault();

    var data = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('cv2d-adding');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: data
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        if (btn) btn.classList.remove('cv2d-adding');
      });
  }, false);

  /* 2) flyt vælgeren ud i bunden af siden --------------------------------- */
  function liftPicker() {
    var modal = document.getElementById('cv2-modal');
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liftPicker);
  else liftPicker();
  setTimeout(liftPicker, 1200);
})();
